import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { map, switchMap, tap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { MeasureManagementService } from './measure-management.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-measure-management',
  templateUrl: './measure-management.component.html',
  styleUrls: ['./measure-management.component.scss']
})

export class MeasureManagementComponent implements OnInit {
  allMeasure: any;
  page: number = 1;
  pageSize: number = 10;
  collectionSize: number;
  rows: any[];
  search: string;
  isSearch: boolean = false;
  searchMeasure: any = '';
  locationUrl: string = window.location.origin;
  alwaysOpen: boolean = true;

  sortIdFn = (a, b) => ('' + a.MEASURE_ID).localeCompare(b.MEASURE_ID);
  statusFilterFn = (list: string[], item) => list.some(status => item.STATUS_MEASURE.indexOf(status) !== -1);
  viewStatusFilterFn = (list: string[], item) => list.some(status => item.IS_VIEW === status);

  filterStatus = [
    { text: 'public', value: 'public' },
    { text: 'private', value: 'private' },
    { text: 'draft', value: 'draft' },
  ];

  filterViewStatus = [
    { text: 'เปิด', value: 0 },
    { text: 'ปิด', value: 1 }
  ];

  constructor(
    public matDialog: MatDialog,
    private measureManagementService: MeasureManagementService,
    private gobalFunctionService: GobalFunctionService
  ) {
  }

  ngOnInit(): void {
    this.getAllMeasure();
    this.gobalFunctionService.setTitle('การจัดการแบบทดสอบ');
  }

  addMeasure() {
    window.open('/measure-management/manage-measure?isEdit=false', '_blank');
  }

  getAllMeasure() {
    this.measureManagementService.getAllDashboardMeasure().subscribe(res => {
      // console.log(res);

      this.allMeasure = res.result;
      // this.refresh();
    })
  }

  edit(row) {
    window.open('/measure-management/manage-measure?isEdit=true&measure_id=' + row.MEASURE_ID, '_blank');
  }

  detail(row) {
    window.open('/measure-management/measure-managament-detail?measure_id=' + row.MEASURE_ID, '_blank');
  }

  openLink(link, is_multi_informant) {
    if(is_multi_informant === 1) {
      window.open(`${link}?IS_MULTI_INFORMANT=1`, '_blank');
    } else {
      window.open(link, '_blank');
    }
  }

  changeStatus(event, measure) {
    const dialogConfig = new MatDialogConfig();
    let body;

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';

    // console.log(measure);


    if (measure.IS_VIEW) {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการเปิดสถานะการมองเห็น ผู้ใช้จะสามารถเห็นแบบทดสอบได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        MEASURE_ID: measure.MEASURE_ID,
        IS_VIEW: 0
      }
    } else {
      dialogConfig.data = {
        title: 'คุณต้องการเปลี่ยนสถานะการมองเห็น?',
        description: 'คุณต้องการปิดสถานะการมองเห็น ผู้ใช้จะไม่สามารถเห็นแบบทดสอบได้',
        actionBtnText: 'ยืนยัน',
        cancleBtnText: 'ยกเลิก'
      }
      body = {
        MEASURE_ID: measure.MEASURE_ID,
        IS_VIEW: 1
      }
    }

    // console.log(body);

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res) {
        this.measureManagementService.updateStatusViewMeasureById(body).pipe(
          map((res2) => {
            // console.log(res2);

            event.source.checked = measure.IS_VIEW;
            this.getAllMeasure();
          })
        ).subscribe();
      } else {
        event.source.checked = !measure.IS_VIEW;
      }
    })
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.searchMeasure = [];
      this.allMeasure.filter(measure => {
        if (measure.MEASURE_NAME.toLowerCase().includes(this.search.toLowerCase()) || measure.MEASURE_ID.toLowerCase().includes(this.search.toLowerCase())) {
          this.searchMeasure.push(measure)
        }
      });
    } else {
      this.isSearch = false
      this.searchMeasure = null;
      this.getAllMeasure();
    }
  }

  exportDate(id, name) {
    const body = {
      MEASURE_ID: id
    }
    this.measureManagementService.exportMeasureById(body).pipe(
      map(res => {
        const _data = [];
        
        res.result.map(d => {
          // console.log(d);

          _data.push({
            USER_ID: d.USER_ID,
            USERNAME: d.USERNAME,
            วันที่ทำ: d.DATE,
            ...d.DATA,
            เป็นผู้เข้าร่วม: d.IS_INFORMANT,
            เชิญโดย: d.PARTICIPANT_FROM,
          })
        })

        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(_data);
        const workbook: XLSX.WorkBook = {
          Sheets: { Sheet1: worksheet },
          SheetNames: ['Sheet1'],
        };

        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
        });

        const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });

        FileSaver.saveAs(data, `${name.replace(/\./g, ' ')}_ ${new Date().toISOString().substring(0, 10)}`);
      })
    ).subscribe();
  }
}
